"use client";

import { useEffect } from "react";

/**
 * A component that automatically applies performance optimizations
 * to improve Core Web Vitals and overall page speed.
 */
const PerformanceOptimizer = () => {
  useEffect(() => {
    // Add lazy loading to all images that don't already have it
    document.querySelectorAll("img:not([loading])").forEach((img) => {
      img.setAttribute("loading", "lazy");
    });

    // Add decoding attribute to images
    document.querySelectorAll("img:not([decoding])").forEach((img) => {
      img.setAttribute("decoding", "async");
    });

    // Preload important resources
    const preloadLinks = [
      { href: "/images/logos/apcg-ubt-white-logo.png", as: "image" },
      { href: "/js/main.js", as: "script" },
    ];

    preloadLinks.forEach((link) => {
      const preloadLink = document.createElement("link");
      preloadLink.rel = "preload";
      preloadLink.href = link.href;
      preloadLink.as = link.as;
      document.head.appendChild(preloadLink);
    });
  }, []);

  return null; // This component doesn't render anything
};

export default PerformanceOptimizer;
